import createBreakpoint from 'shared-tokens/utils/breakpoints';

export const mainCls = 'prp-bkmsrp';

const brpM = createBreakpoint('m');

export default {
  [mainCls]: {
    height: '100%',
  },
  [`${mainCls}__bod`]: {
    maxHeight: '100%'
  },
  [`${mainCls}__fut`]: {
    paddingTop: 8,
    paddingBottom: 8,
    [brpM]: {
      paddingTop: 12,
      paddingBottom: 12,
    },
  },
};
